import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router';

import { getFirstModuleRoute } from '@/shared/services/helpers/modules';
import { useAppSelector } from '@/store';

import useLogout from './layout/entities/profile-menu/hooks/useLogout';

/**
 * Корень кабинета: отдельной главной нет — сотрудник попадает в первый открытый
 * ему раздел. Если разделов нет, объясняем это и предлагаем выйти.
 */
const StartRedirect: React.FC = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const logout = useLogout();
  const modules = useAppSelector((state) => state.session.modules);

  const startRoute = getFirstModuleRoute(modules);

  if (startRoute) return <Navigate to={`/${lang}/${startRoute}`} replace />;

  return (
    <Result
      status="403"
      title={t('session.noModules.title')}
      subTitle={t('session.noModules.description')}
      extra={<Button onClick={logout}>{t('layout.profile.logout')}</Button>}
    />
  );
};

export default StartRedirect;
